import * as React from 'react';

import { FacebookProvider, Login } from 'react-facebook';
import { FaFacebook } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

import Button from '../atoms/Button';

export const FacebookButton = ({ onCompleted, label, disabled }) => {
  const { t } = useTranslation();
  const isDisabled = disabled;

  return (
    <FacebookProvider appId={process.env.REACT_APP_FACEBOOK_ID}>
      <Login scope="email" onCompleted={onCompleted}>
        {({ handleClick }) => (
          <Button
            mt={4}
            type="button"
            variant="outlined"
            color="primary"
            startIcon={<FaFacebook />}
            fullWidth
            onClick={handleClick}
            disabled={isDisabled}
          >
            {!isDisabled ? label : t('button.disabled')}
          </Button>
        )}
      </Login>
    </FacebookProvider>
  );
};
